import { render, staticRenderFns } from "./Tabela-6.vue?vue&type=template&id=78ba560c&scoped=true&"
import script from "./Tabela-6.vue?vue&type=script&lang=js&"
export * from "./Tabela-6.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78ba560c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/williamsalmeida/www/hubcompras/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('78ba560c')) {
      api.createRecord('78ba560c', component.options)
    } else {
      api.reload('78ba560c', component.options)
    }
    module.hot.accept("./Tabela-6.vue?vue&type=template&id=78ba560c&scoped=true&", function () {
      api.rerender('78ba560c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/tabelas/Tabela-6.vue"
export default component.exports